import { Link } from 'react-router-dom';
import cn from 'bem-cn';

import { HeaderBackButtonProps } from './HeaderBackButton.types';

import './HeaderBackButton.scss';

const b = cn('header');

export const HeaderBackButton: React.FC<HeaderBackButtonProps> = ({ to, onClick, className }) => {
    const backContent = (
        <button className={`${b('back-button')} ${className}`}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.9343 2.08594L16.0657 3.21731L7.26274 12.0202L16.0657 20.8232L14.9343 21.9545L5 12.0202L14.9343 2.08594Z"
                    fill="black"
                    fillOpacity="0.9"
                />
            </svg>
        </button>
    );

    if (to) {
        return <Link to={to}>{backContent}</Link>;
    }

    return <div onClick={onClick}>{backContent}</div>;
};
